/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IInversionMutation,
  IInversionMutationInterface,
} from "../IInversionMutation";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence",
        type: "uint32[72]",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "inversionMutation",
    outputs: [
      {
        internalType: "uint32[72]",
        name: "",
        type: "uint32[72]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IInversionMutation__factory {
  static readonly abi = _abi;
  static createInterface(): IInversionMutationInterface {
    return new utils.Interface(_abi) as IInversionMutationInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IInversionMutation {
    return new Contract(address, _abi, signerOrProvider) as IInversionMutation;
  }
}
